import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc vị trí
export function locViTri(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/vi-tri/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy vị trí
export function layViTri(id: number) {
  try {
    return axiosApi.get('/cham-cong/vi-tri/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo vị trí
export function taoViTri(params: any) {
  try {
    return axiosApi.post('/cham-cong/vi-tri/', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật vị trí
export function capNhatViTri(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/vi-tri/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa vị trí
export function xoaViTri(id: number) {
  try {
    return axiosApi.delete('/cham-cong/vi-tri/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
